/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "8505890d403d21350c2dc8b49d2bc7a0e007a744";
